/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Slider_CtaInputs */

const en_app_slider_cta = /** @type {(inputs: App_Slider_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Now`)
};

const es_app_slider_cta = /** @type {(inputs: App_Slider_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probar ahora`)
};

/**
* | output |
* | --- |
* | "Try Now" |
*
* @param {App_Slider_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_slider_cta = /** @type {((inputs?: App_Slider_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Slider_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_slider_cta(inputs)
	return en_app_slider_cta(inputs)
});